import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {ApiResponse, BaseComponent, CompoApiService, ConfirmDialogComponent, CrmIssue, Document, FileService} from 'compob2b-libs';
import {concatMap, filter, finalize, map, switchMap, takeUntil, tap} from 'rxjs/operators';
import {FileUploader} from 'ng2-file-upload';
import {from, Observable} from 'rxjs';
import {DocumentFile} from '../../../../../admin-shared/crud-components/documents-uploader/documents-uploader.component';
import {translations} from '../../../../../../environments/translations.ru';
import {NbDialogService} from '@nebular/theme';

@Component({
    selector: 'app-uploaad',
    templateUrl: './issue-upload.component.html',
    styleUrls: ['./issue-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueUploadComponent extends BaseComponent implements OnInit {
  private icons = ['3g2', '3ga', '3gp', '7z', 'aa', 'aac', 'ac', 'accdb', 'accdt', 'ace', 'adn', 'ai', 'aif', 'aifc', 'aiff', 'ait', 'amr', 'ani', 'apk', 'app', 'applescript', 'asax', 'asc', 'ascx', 'asf', 'ash', 'ashx', 'asm', 'asmx', 'asp', 'aspx', 'asx', 'au', 'aup', 'avi', 'axd', 'aze', 'bak', 'bash', 'bat', 'bin', 'blank', 'bmp', 'bowerrc', 'bpg', 'browser', 'bz2', 'bzempty', 'c', 'cab', 'cad', 'caf', 'cal', 'cd', 'cdda', 'cer', 'cfg', 'cfm', 'cfml', 'cgi', 'chm', 'class', 'cmd', 'code-workspace', 'codekit', 'coffee', 'coffeelintignore', 'com', 'compile', 'conf', 'config', 'cpp', 'cptx', 'cr2', 'crdownload', 'crt', 'crypt', 'cs', 'csh', 'cson', 'csproj', 'css', 'csv', 'cue', 'cur', 'dart', 'dat', 'data', 'db', 'dbf', 'deb', 'default', 'dgn', 'dist', 'diz', 'dll', 'dmg', 'dng', 'doc', 'docb', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'download', 'dpj', 'ds_store', 'dsn', 'dtd', 'dwg', 'dxf', 'editorconfig', 'el', 'elf', 'eml', 'enc', 'eot', 'eps', 'epub', 'eslintignore', 'exe', 'f4v', 'fax', 'fb2', 'fla', 'flac', 'flv', 'fnt', 'folder', 'fon', 'gadget', 'gdp', 'gem', 'gif', 'gitattributes', 'gitignore', 'go', 'gpg', 'gpl', 'gradle', 'gz', 'h', 'handlebars', 'hbs', 'heic', 'hlp', 'hs', 'hsl', 'htm', 'html', 'ibooks', 'icns', 'ico', 'ics', 'idx', 'iff', 'ifo', 'image', 'img', 'iml', 'in', 'inc', 'indd', 'inf', 'info', 'ini', 'inv', 'iso', 'j2', 'jar', 'java', 'jpe', 'jpeg', 'jpg', 'js', 'json', 'jsp', 'jsx', 'key', 'kf8', 'kmk', 'ksh', 'kt', 'kts', 'kup', 'less', 'lex', 'licx', 'lisp', 'lit', 'lnk', 'lock', 'log', 'lua', 'm', 'm2v', 'm3u', 'm3u8', 'm4', 'm4a', 'm4r', 'm4v', 'map', 'master', 'mc', 'md', 'mdb', 'mdf', 'me', 'mi', 'mid', 'midi', 'mk', 'mkv', 'mm', 'mng', 'mo', 'mobi', 'mod', 'mov', 'mp2', 'mp3', 'mp4', 'mpa', 'mpd', 'mpe', 'mpeg', 'mpg', 'mpga', 'mpp', 'mpt', 'msg', 'msi', 'msu', 'nef', 'nes', 'nfo', 'nix', 'npmignore', 'ocx', 'odb', 'ods', 'odt', 'ogg', 'ogv', 'ost', 'otf', 'ott', 'ova', 'ovf', 'p12', 'p7b', 'pages', 'part', 'pcd', 'pdb', 'pdf', 'pem', 'pfx', 'pgp', 'ph', 'phar', 'php', 'pid', 'pkg', 'pl', 'plist', 'pm', 'png', 'po', 'pom', 'pot', 'potx', 'pps', 'ppsx', 'ppt', 'pptm', 'pptx', 'prop', 'ps', 'ps1', 'psd', 'psp', 'pst', 'pub', 'py', 'pyc', 'qt', 'ra', 'ram', 'rar', 'raw', 'rb', 'rdf', 'rdl', 'reg', 'resx', 'retry', 'rm', 'rom', 'rpm', 'rpt', 'rsa', 'rss', 'rst', 'rtf', 'ru', 'rub', 'sass', 'scss', 'sdf', 'sed', 'sh', 'sit', 'sitemap', 'skin', 'sldm', 'sldx', 'sln', 'sol', 'sphinx', 'sql', 'sqlite', 'step', 'stl', 'svg', 'swd', 'swf', 'swift', 'swp', 'sys', 'tar', 'tax', 'tcsh', 'tex', 'tfignore', 'tga', 'tgz', 'tif', 'tiff', 'tmp', 'tmx', 'torrent', 'tpl', 'ts', 'tsv', 'ttf', 'twig', 'txt', 'udf', 'vb', 'vbproj', 'vbs', 'vcd', 'vcf', 'vcs', 'vdi', 'vdx', 'vmdk', 'vob', 'vox', 'vscodeignore', 'vsd', 'vss', 'vst', 'vsx', 'vtx', 'war', 'wav', 'wbk', 'webinfo', 'webm', 'webp', 'wma', 'wmf', 'wmv', 'woff', 'woff2', 'wps', 'wsf', 'xaml', 'xcf', 'xfl', 'xlm', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xml', 'xpi', 'xps', 'xrb', 'xsd', 'xsl', 'xspf', 'xz', 'yaml', 'yml', 'z', 'zip', 'zsh'];

  @Input() issue: CrmIssue;
  @Output() onBeginUpload = new EventEmitter();
  @Output() onDone = new EventEmitter();

  private fileInput: ElementRef;

  @ViewChild('fileInput', {static: false}) set taskContent(content: ElementRef) {
    if (content) {
      this.fileInput = content;
    }
  }

  public uploading = false;
  uploader: FileUploader;
  attaches: Document[] = [];

  public readonly translations = translations;

  constructor(private readonly apiService: CompoApiService,
              private readonly fileService: FileService) {
    super();

    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 25 * 1024 * 1024,
    });
  }

  ngOnInit(): void {
    this.getAttaches().pipe(
      tap((response: Document[]) => this.handleAttachesResponse(response)),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  private handleAttachesResponse(response: Document[]) {
    this.attaches = response
      .filter(item => !item.deleted)
      .map(item => {
        if (item.fileName) {

          const ext = item.fileName.toLowerCase().split('.').pop();
          if (ext && this.icons.indexOf(ext) >= 0) {
            item.icon = ext;
          }
        }
        return item;
      })
    ;
    this.cdr.detectChanges();
  }

  upload() {
    if (this.uploader.queue.length) {
      this.onBeginUpload.emit();
      this.uploading = true;
      from(this.uploader.queue)
        .pipe(
          map(uploadingFile => uploadingFile._file),
          concatMap((uploadingFile: File) => this.uploadFile(uploadingFile)),
          tap((resp: ApiResponse<Document>) => this.successLoadingDocument(resp)),
          finalize(() => {
            this.uploader.clearQueue();
            this.uploading = false;
            this.cdr.detectChanges();

            this.onDone.emit();
          }),
          takeUntil(this.unsubscribe)
        ).subscribe();
    }
  }

  formatBytes(bytes, decimals?) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)).toFixed() + ' ' + sizes[i];
  }

  private uploadFile(uploadingFile: File): Observable<any> {
    return this.apiService.postForm<DocumentFile, string>('/issue/' + this.issue.id + '/upload-document', {file: uploadingFile});
  }

  private successLoadingDocument(res: ApiResponse<Document>) {
    this.attaches.push(res.data);
    this.cdr.detectChanges();
  }

  private getAttaches(): Observable<Document[]> {
    return this.apiService.get<Document[]>('/issue/' + this.issue.id + '/attaches')
      .pipe(map(response => response.data));
  }

  download(doc: Document) {
    this.fileService.downloadUrl('/documents/files/download/' + doc.fileName).pipe(
      takeUntil(this.unsubscribe),
      tap((response: Blob) => this.handleAttachResponse(doc, response)),
    ).subscribe();
  }

  private handleAttachResponse(doc: Document, response: Blob) {
    if (response.size !== 0) {
      FileService.saveAs(response, doc.header);
    }
  }

  deleteAttach(doc: Document) {
    this.dialogService.open(ConfirmDialogComponent, {
      context: {
        description: translations.confirmDelete + ' ' + translations.documents + '?'
      },
    }).onClose.pipe(
      filter(result => result === true),
      switchMap(_ => this.deleteIssueDocument(doc.id)),
      tap(_ => this.removeDocumentFromModel(doc)),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  private deleteIssueDocument(id: number): Observable<any> {
    return this.apiService.remove('/issue/' + this.issue.id + '/document/' + id);
  }

  protected removeDocumentFromModel(document: Document) {
    const index = this.attaches.findIndex(el => el.id === document.id);
    this.attaches.splice(index, 1);
    this.cdr.detectChanges();
  }

  public selectFile() {
    if (!this.uploading) {
      this.fileInput.nativeElement.click();
    }
  }
}
